import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EnquiryForm from '../../../components/forms/EnquiryForm';
import { useEnquiryApi } from '../../../hooks/useEnquiryApi';
import { useNavigate } from 'react-router-dom';
import { EnquiryDTO } from '../../../services/apiClient';

const EnquiryCreate: React.FC = () => {
  const { create, isLoading } = useEnquiryApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Enquiries', href: '/admin/enquiries' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EnquiryDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/enquiries');
    } catch (error) {
      console.error('Error creating Enquiry:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/enquiries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Enquiry.Edit'
    >
      <EnquiryForm
        initialValues={{} as EnquiryDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/enquiries')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default EnquiryCreate;